import { createContext, ReactNode, useState } from "react";
import { Navigate } from "react-router-dom";
import { removeStoredToken } from "src/utils/auth";

type Props = {
  children?: ReactNode;
};

type IAuthContext = {
  authenticated: boolean;
  setAuthenticated: (newState: boolean) => void;
  logout: () => void;
};

const initialValue = {
  authenticated: false,
  setAuthenticated: () => {},
  logout: () => {},
};

const AuthContext = createContext<IAuthContext>(initialValue);

const AuthProvider = ({ children }: Props) => {
  //Initializing an auth state with false value (unauthenticated)
  const [authenticated, setAuthenticated] = useState(
    initialValue.authenticated
  );

  const logout = () => {
    setAuthenticated(false);
    removeStoredToken();
    <Navigate to="/login" replace />;
  };

  return (
    <AuthContext.Provider value={{ authenticated, setAuthenticated, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
